<template>
  <page>
    <form>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-calendar-range</v-icon>
            <v-toolbar-title>Date Ranges</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <!-- Inward / RI Outward Tran Date -->
                <v-flex xs12 md6>
                  <cal-picker v-model="form.irioTranDateFrm" :label="labels.irioTranDateFrm" v-validate="'required|start_after_today'" :data-vv-as="labels.irioTranDateFrm" data-vv-name="irioTranDateFrm" :error-messages="errors.collect('irioTranDateFrm')" :max="new Date()"></cal-picker>
                </v-flex>
                <v-flex xs12 md6>
                  <cal-picker v-model="form.irioTranDateTo" :label="labels.irioTranDateTo" v-validate="irioTranDateFrmValidate" :data-vv-as="labels.irioTranDateTo" data-vv-name="irioTranDateTo" :error-messages="errors.collect('irioTranDateTo')" :min="form.irioTranDateFrm" :max="new Date()" ></cal-picker>
                </v-flex>
                <!--YTD Claims Payment Tran -->
                <v-flex xs12 md6>
                  <cal-picker v-model="form.ycpTranDateFrm" :label="labels.ycpTranDateFrm" v-validate="'required|start_after_today'" :data-vv-as="labels.ycpTranDateFrm" data-vv-name="ycpTranDateFrm" :error-messages="errors.collect('ycpTranDateFrm')" :max="new Date()"></cal-picker>
                </v-flex>
                <v-flex xs12 md6>
                  <cal-picker v-model="form.ycpTranDateTo" :label="labels.ycpTranDateTo" v-validate="ycpTranDateFrmValidate" :data-vv-as="labels.ycpTranDateTo" data-vv-name="ycpTranDateTo" :error-messages="errors.collect('ycpTranDateTo')" :min="form.ycpTranDateFrm" :max="new Date()" ></cal-picker>
                </v-flex>
                <!-- -->
                <v-flex xs12 md6>
                  <cal-picker v-model="form.lstYrOutAsAt" :label="labels.lstYrOutAsAt" v-validate="'required|start_after_today'" :data-vv-as="labels.lstYrOutAsAt" data-vv-name="lstYrOutAsAt" :error-messages="errors.collect('lstYrOutAsAt')" ></cal-picker>
                </v-flex>
              </v-layout>
            </v-container>
        </v-card-text>
      </v-card>
       <v-spacer class="mt-2"></v-spacer>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex lg6 xs12 class="pt-3">
            <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-flex lg6 xs12>
            <v-checkbox v-model="form.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>
    </form>
  </page>
</template>
<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import clone from 'clone'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      labels: {
        irioTranDateFrm: 'Inward / RI Outward Tran Date From',
        irioTranDateTo: 'Inward / RI Outward Tran Date To',
        ycpTranDateFrm: 'YTD Claims Payment Tran Date From',
        ycpTranDateTo: 'YTD Claims Payment Tran Date To',
        lstYrOutAsAt: 'Last Year Outstanding Claims As At',
        export: 'Export to',
        printRptRunTime: 'Print report runtime parameters'
      },
      form: {
        irioTranDateFrm: null,
        irioTranDateTo: null,
        ycpTranDateFrm: null,
        ycpTranDateTo: null,
        lstYrOutAsAt: null,
        printRptRunTime: false
      },
      menu: {},
      submitting: false
    }
  },
  created() {
    this.$validator.extend('start_after_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than the date of application.`
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const tomorrow = new Date(today)
          tomorrow.setDate(tomorrow.getDate() + 1)
          const startDate = removeTime(value)
          return (isAfter(tomorrow, startDate))
        } else return true
      }
    })
    this.doInit()
  },
  methods: {
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let clonedForm = clone(this.form)
          await this.$http.post(apiURI, clonedForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doInit() {
      this.setMenu()
    },
    async setMenu() {
      try {
        if (this.$store.state.reports.custom1Reports.init !== 1) {
          await this.$store.dispatch('custom1ReportsInit')
        }
        const apiURI = this.rptMenu.riBusStat
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.custom1Reports.menu
    },
    supportedList() {
      const result = []
      result.push(reportFormat.PDF)
      result.push(reportFormat.XLSX)
      return result
    },
    irioTranDateFrmValidate() {
      const result = 'required|start_after_today|from_to_date:' + this.form.irioTranDateFrm
      return result
    },
    ycpTranDateFrmValidate() {
      const result = 'required|start_after_today|from_to_date:' + this.form.ycpTranDateFrm
      return result
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>
